import { useEffect } from 'react';

import { getStringWithoutHash } from 'utilitys/helpers/general';

import useCustomPageSubTitle from 'hooks/useCustomPageSubTitle';

import { ISetSubTitleForExport } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

interface Props {
    id: string;
    widgetId?: string;
    projectId?: number | null;
    contractId?: number | null;
    latestVersionId?: number;
    title: string;
    setSubTitleForExport?: ISetSubTitleForExport;
    customSubTitle?: string | null;
}

export type UseBaseWidget = ReturnType<typeof useBaseWidget>;

export const useBaseWidget = ({
    id,
    widgetId,
    projectId,
    contractId,
    latestVersionId,
    title,
    setSubTitleForExport,
    customSubTitle = null as string | null | undefined,
}: Props) => {
    let subTitle = useCustomPageSubTitle({ projectId, contractId, latestVersionId });

    if (customSubTitle) {
        subTitle = customSubTitle;
    }

    // add subtitle when export pinboard to PPTX
    useEffect(() => {
        setSubTitleForExport && setSubTitleForExport({ widgetId, subTitle, title });
    }, [widgetId, subTitle, title]);

    // link back to original/source page. id is used as hash for window scrolling to widget position in the page
    const route = `${getStringWithoutHash(window.location.href)}#${id}`;

    return {
        subTitle,
        route,
    };
};
